import { render, staticRenderFns } from "./VxSlider.vue?vue&type=template&id=5aff87aa&lang=html&"
import script from "./VxSlider.vue?vue&type=script&lang=js&"
export * from "./VxSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports